var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',_vm._g(_vm._b({attrs:{"disabled":_vm.loading || _vm.disabled}},'b-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?[_c('b-spinner',{attrs:{"small":"","type":"grow"}}),(_vm.loadingText)?[_vm._v(_vm._s(_vm.loadingText))]:(!_vm.useLabel)?[_vm._v(_vm._s(_vm.$t("common.loading")))]:_vm._t("default")]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }